import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import Localize from 'components/Localize';
import { parseInternshipId } from 'utils/uri';
import { InternshipInfoWrapper, InfoWrapper } from './InternshipInfoStyled';

// Extrahiert die BuB-Namen aus der nested education_providers-Liste (M2M des
// Internship-Objekts) zu "Vorname Nachname, ..." — leere/unvollständige Einträge
// werden übersprungen; kein BuB -> leerer String (Zeile wird ausgeblendet).
export const formatProviderNames = (educationProviders) => (educationProviders || [])
  .map((p) => `${p?.esuser?.user?.first_name || ''} ${p?.esuser?.user?.last_name || ''}`.trim())
  .filter(Boolean)
  .join(', ');

const InternshipInfo = ({
  internship, educationProviders, loading, margin, padding,
}) => {
  if (loading || !internship) {
    return null;
  }
  const providerNames = formatProviderNames(educationProviders);
  return (
    <InfoWrapper>
      <div>
        <InternshipInfoWrapper margin={margin} padding={padding}>
          <Localize id="internship-period" />
          {': '}
        </InternshipInfoWrapper>
        {internship.company_name && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            <Localize id="company" />
            {': '}
          </InternshipInfoWrapper>
        )}
        {internship.company_address && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            <Localize id="company-address" />
            {': '}
          </InternshipInfoWrapper>
        )}
        {internship.company_employee && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            <Localize id="contact-person" />
            {': '}
          </InternshipInfoWrapper>
        )}
        {internship.company_phone && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            <Localize id="company-phone" />
            {': '}
          </InternshipInfoWrapper>
        )}
        {providerNames && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            <Localize id="education-provider" />
            {': '}
          </InternshipInfoWrapper>
        )}
      </div>
      <div>
        <InternshipInfoWrapper margin={margin} padding={padding}>
          {moment(internship.start).format('DD.MM.YYYY')} -{' '}
          {moment(internship.end).format('DD.MM.YYYY')}
        </InternshipInfoWrapper>
        {internship.company_name && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            {internship.company_name}
          </InternshipInfoWrapper>
        )}
        {internship.company_address && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            {internship.company_address}
          </InternshipInfoWrapper>
        )}
        {internship.company_employee && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            {internship.company_employee}
          </InternshipInfoWrapper>
        )}
        {internship.company_phone && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            {internship.company_phone}
          </InternshipInfoWrapper>
        )}
        {providerNames && (
          <InternshipInfoWrapper margin={margin} padding={padding}>
            {providerNames}
          </InternshipInfoWrapper>
        )}
      </div>
    </InfoWrapper>
  );
};

InternshipInfo.propTypes = {
  loading: PropTypes.bool.isRequired,
  internship: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    company_name: PropTypes.string,
    company_address: PropTypes.string,
    company_phone: PropTypes.string,
    company_employee: PropTypes.string,
  }),
  // Echtes Internship-Objekt liefert die zugeordneten BuB (M2M, nested mit Namen);
  // die Praktikums-Eckdaten oben stammen dagegen aus dem InternshipRequest.
  educationProviders: PropTypes.arrayOf(PropTypes.shape({
    esuser: PropTypes.shape({
      user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      }),
    }),
  })),
  margin: PropTypes.string,
  padding: PropTypes.string,
};

InternshipInfo.defaultProps = {
  internship: null,
  educationProviders: [],
  margin: null,
  padding: null,
};

export const mapStateToProps = (
  {
    internshipRequest: { data, loading, error },
    internships,
  },
  { selectedInternshipId },
) => ({
  internship: data
    ?.filter(({ internship }) => !!internship)
    ?.find(
      ({ internship }) => parseInt(parseInternshipId(internship), 10) === selectedInternshipId,
    ),
  educationProviders:
    internships?.data?.byId?.[selectedInternshipId]?.education_providers || [],
  loading,
  error,
});

export default connect(mapStateToProps)(InternshipInfo);
